module.exports = __webpack_public_path__ + "img/cf1f643bc1244f5e8e37767bc946d607.d6b5b9ad.png";